import { createReducer, createSlice, combineReducers } from "@reduxjs/toolkit";
import { createAction } from 'redux-actions';

export const setShowFraudWarning = createAction("SET_SHOW_FRAUD_WARNING");
export const setShowCookieWarning = createAction("SET_SHOW_COOKIE_WARNING")
export const setVideoPlayerPlaying = createAction("SET_VIDEO_PLAYER_PLAYING");
export const setVideoPlayerAudioTrack = createAction("SET_VIDEO_PLAYER_AUDIO_TRACK");
export const setOnLoadShowFraudWarning = createAction("SET_ON_LOAD_SHOW_FRAUD_WARNING");
export const setEntranceVideoInterval = createAction("SET_ENTRANCE_VIDEO_INTERVAL");


const reducer = createReducer({
  showFraudWarning: false,
  showCookieWarning: false,
  videoPlayerPlaying: false,
  onLoadShowFraudWarning: false,
  entranceVideoInterval: 90
}, {
  [setOnLoadShowFraudWarning]: (state, action) => {
    state.onLoadShowFraudWarning = action.payload
  },
  [setShowFraudWarning]: (state, action) => {
    state.showFraudWarning = action.payload
  },
  [setShowCookieWarning]: (state, action) => {
    state.showCookieWarning = action.payload
  },
  [setVideoPlayerAudioTrack]: (state, action) => {
    state.videoPlayerAudioTrack = action.payload
  },
  [setVideoPlayerPlaying]: (state, action) => {
    state.videoPlayerPlaying = action.payload
  },
  [setEntranceVideoInterval]: (state, action) => {
    try {
      state.entranceVideoInterval = parseInt(action.payload)

      if(state.entranceVideoInterval == null || state.entranceVideoInterval < 1) {
        state.entranceVideoInterval = 180
      }
    } catch(ex) {
      state.entranceVideoInterval = 180
    }
  },
})
export default reducer //combineReducers({videoPlayer: reducer})